import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class ModCommunityRoute extends DiscourseRoute {
  @service store;

  queryParams = {
    order: { refreshModel: true },
  };

  async model({ order = "latest" }) {
    const topicList = await this.store.findFiltered("topicList", {
      filter: "community-navigation/topics",
      params: { section: "mod", order, page: 0 },
    });
    return {
      topicList,
      order,
      title: i18n("community_navigation.mod_community"),
    };
  }

  titleToken() {
    return i18n("community_navigation.mod_community");
  }
}
